import type { IndustryCodeName } from "app/pages/sales-intelligence/domain/industry/types/codes";
import { type InclusionOption, inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";
import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";

export enum TrackAction {
    Add = "add",
    Remove = "remove",
}

export enum TrackType {
    Industry = "insustry",
}

const actionTextMap: Readonly<Record<InclusionOption, string | undefined>> = {
    [inclusionOptionMap.includeOnly]: "include",
    [inclusionOptionMap.excludeOnly]: "exclude",
    [inclusionOptionMap.any]: "any",
};

export default function createIndustryFilterEventsTrackingService(track: TrackFn) {
    const trackValueChange = (value: string, action: TrackAction, type: TrackType) => {
        track("lead gen filters", "click", `${action}/${type}/${value}`);
    };

    return {
        trackIndustryAdd(value: string) {
            trackValueChange(value, TrackAction.Add, TrackType.Industry);
        },
        trackIndustryRemove(value: string) {
            trackValueChange(value, TrackAction.Remove, TrackType.Industry);
        },
        trackIndustrySearch(term: string, inclusion: InclusionOption) {
            track("lead gen filters", `search industry to ${actionTextMap[inclusion]}`, `website/industry/${term}`);
        },
    };
}
